import { useCallback } from 'react'

import { indexes } from '@mab-common/utils'

import useSearchAnalyst, {
  type TSearchAnalystEventProps,
} from '~/services/elastic/analyst'
import { toURL } from '~/utils/urlResolver'

import Link from '../Link/Link'
import Text, { TextSizes } from '../Text/Text'

import styles from './GenreCard.module.css'
import EsIndexTypes = indexes.EsIndexTypes
import { multiPostHogEventPusher } from '~/utils/analyticsPusher'

export interface GenreCardProps {
  name: string
  slug: string
  _id: string
  count?: number
  testID?: string
  searchInsightsEvent?: TSearchAnalystEventProps
}

export default function GenreCard({
  name,
  slug,
  testID,
  searchInsightsEvent,
}: GenreCardProps) {
  const { sendSearchInsightsEvent } = useSearchAnalyst()

  const onGenreClick = useCallback(async () => {
    await multiPostHogEventPusher([
      {
        eventType: searchInsightsEvent?.name || `${name} genre clicked`,
      },
    ])

    if (!searchInsightsEvent) return

    sendSearchInsightsEvent(searchInsightsEvent.method, {
      indexType: EsIndexTypes.ARTWORKS,
      eventName: searchInsightsEvent.name,
      filters: [`genres.name:'${name}'`],
    })
  }, [name, searchInsightsEvent])

  return (
    <div data-testid={testID}>
      <Link
        href={toURL({ slug, _type: 'genre' })}
        onClick={onGenreClick}
        className={styles.base}
      >
        <Text size={TextSizes.primaryTitleSml}>{name}</Text>
      </Link>
    </div>
  )
}
